export class PortfolioCompositionTableConfigs {
  static readonly MaximumSetupPerTable = 6;
  static readonly TableFirstColumnWidthInPixel = 315;
  static readonly TableDefaultColumnWidthInPixel = 170;
}

export class FeePortfolioDetailsConstants {
  static readonly RetailInsurancePoliciesRegex =
    /Retail insurance policies in (IDPS|Super): .*/g;
  static readonly TotalPortfolioValue = "Total portfolio value";
  static readonly InvestmentsAndOtherHoldings =
    "Investments and other holdings";
  static readonly TotalDifferentInvestmentsHeld =
    "Total number of different investments held";
  static readonly NumberOfRetailInsurancePolices =
    "Number of retail insurance polices";
  static readonly BalanceInCFSEdgeMenus = "Balance in CFS Edge menus";
  static readonly BalanceInExpandEssentialMenus =
    "Balance in Expand Essential menus";
  static readonly BalanceInNorthMenus = "Balance in North menus";
  static readonly ManageAccountTransactionOutside = "Transactions outside managed accounts (Next 12 months)";
  static readonly ManageAccountTransactionWithin = "Transactions within managed accounts (Next 12 months)";
}
